import { ListItem } from 'tiptap-extensions';

/**
 * `<li>` with its inline `style` preserved.
 *
 * Quill records list indentation as `class="ql-indent-N"` on the *list item*,
 * which `normaliseQuillHtml` converts to `style="margin-left:Nx2em"`. The stock
 * `ListItem` from `tiptap-extensions` declares no attributes at all, so that
 * style — and with it every indent level in every legacy nested list — was
 * dropped the first time an old asset was opened and saved.
 *
 * Like `StyledSpan`, the whole attribute is carried verbatim rather than being
 * parsed into typed attributes, so any other inline style on an `<li>` survives
 * too. Everything else (content model, keymap, `defining`) comes from the base
 * extension untouched.
 */
export default class StyledListItem extends ListItem {
  get schema() {
    const base = super.schema;

    return {
      ...base,
      attrs: {
        ...(base.attrs || {}),
        style: { default: null },
      },
      parseDOM: [
        {
          tag: 'li',
          getAttrs: (dom) => {
            const style = (dom.getAttribute('style') || '').trim();
            return { style: style || null };
          },
        },
      ],
      toDOM: node => ['li', node.attrs.style ? { style: node.attrs.style } : {}, 0],
    };
  }
}
